import React from 'react';
import {
  RiBookOpenLine,
  RiFileChartLine,
  RiTimeLine,
  RiUploadCloud2Line,
} from 'react-icons/ri';

const stats = [
  {
    icon: RiUploadCloud2Line,
    number: '1',
    label: 'facture déposée',
    title: 'Vous déposez, on s\'occupe du reste',
    desc: 'Importez une facture : montants, TVA et écritures comptables sont traités automatiquement pour vous.',
  },
  {
    icon: RiTimeLine,
    number: '80%',
    label: 'de temps gagné',
    title: 'Fini les heures perdues',
    desc: 'Plus de tableurs ni de ressaisie manuelle. Concentrez-vous sur votre activité, pas sur la paperasse.',
  },
  {
    icon: RiBookOpenLine,
    number: '0',
    label: 'comptable requis',
    title: 'Comptabilité sans jargon',
    desc: 'Interface claire, pensée pour les entrepreneurs. Aucune formation comptable nécessaire pour démarrer.',
  },
  {
    icon: RiFileChartLine,
    number: '5',
    label: 'rapports prêts à partager',
    title: 'PDF pro en 1 clic',
    desc: 'Bilan, balance, grand livre, livre journal et compte de résultat - exportables instantanément.',
  },
];

const EasyComptaSection = () => {
  return (
    <section id="avantages" className="lp-section lp-stats">
      <div className="lp-container">
        <header className="lp-section-header lp-reveal">
          <div className="lp-badge">
            <span className="lp-badge-dot" />
            Résultats concrets
          </div>
          <h2 className="lp-title">
            Des chiffres qui parlent aux{' '}
            <span className="lp-title-accent">entrepreneurs</span>
          </h2>
          <p className="lp-subtitle lp-subtitle-center">
            Moins de temps perdu, moins de stress - plus de clarté sur vos
            finances
          </p>
        </header>

        <div className="lp-stats-grid">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <article
                key={stat.title}
                className={`lp-stat-card lp-reveal lp-reveal-delay-${(index % 4) + 1}`}
              >
                <div className="lp-stat-icon">
                  <Icon />
                </div>
                <p className="lp-stat-number">{stat.number}</p>
                <p className="lp-stat-label">{stat.label}</p>
                <h4>{stat.title}</h4>
                <p>{stat.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EasyComptaSection;
